export const formatThaiDate = (value) => {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Bangkok'
    };
    
    return new Intl.DateTimeFormat('th-TH', options).format(new Date(value));
}